<template>
  <div class="customer">
    <!-- 按钮 -->
    <filter-panel style="width: 100%"
                  :data="group"
                  @search="filterChange"></filter-panel>
    <!-- 列表 -->
    <data-list :table-style="{ name: 'mixture' }"
               :data="data"
               :columns="columns"
               :loading="loading"
               :page="page"
               :page-size="page.pageSize"
               :btnList="btnList"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"
               @sort-change="sortChange"></data-list>
    <!-- 编辑弹窗 -->
    <el-dialog title="客户"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               width="30%">
      <form-combination :form-data="groups"></form-combination>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   :loading="dialogLoading"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增确认 -->
    <el-dialog class="customerList"
               :visible.sync="customerDialogVisible"
               width="70%"
               top="4vh">
      <el-row :gutter="10">
        <!-- 客户列表 -->
        <el-col :span="6">
          <el-row class="list">
            <el-col :span="24"
                    v-for="(item, index) in customerList"
                    :key="index"
                    @click.native="showCustomerList(item.customerBusinessLineId, index)"
                    :style="{ backgroundColor: item.bgc }"
                    class="customerListItem">
              <popover-text :text="item.custName"
                            :subText="item.custName"></popover-text>
              <div>{{ item.orderCount }}</div>
            </el-col>
          </el-row>
        </el-col>
        <!-- 客户信息 -->
        <el-col :span="18"
                class="list">
          <form-combination ref="customerAffirm"
                            :form-data="customerGroups"></form-combination>
        </el-col>
      </el-row>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click.native="customerDialogVisibleCancle">取 消</el-button>
        <el-button type="primary"
                   @click="showDialogSecond">继续订单确认</el-button>
      </span>
    </el-dialog>

    <!-- 订单二次确认 -->
    <serviceconfirmation ref="serviceconfirmation"
                         :orderList="orderList"
                         :nextOrderCountTotal="nextOrderCountTotal"
                         :orderType="orderType"
                         :agentName="agentName"
                         :serviceConfirmation="serviceConfirmation"
                         @close:orderDialogVisible="val => (orderDialogVisible = val)"
                         @confirm="revert"
                         @showOrderList="showOrderList"></serviceconfirmation>

    <!-- 续费率图表 -->
    <dialog-form :dialogVisible="showDialog"
                 :attributes="attributes"
                 :showBtn="false"
                 @close:dialogVisible="val => (showDialog = val)">
      <radar-map slot="main"
                 :showTitle="false"
                 :showShadow="false"
                 :chartData="chartData"
                 :condition="condition"
                 :extend="extend"
                 :chartConfig="chartConfig"
                 legendPosition="right">
        <div class="average"
             slot="average">
          <div>
            <span class="data">客户预测续费率：{{ renewalRate.renewProb }}%</span>
            <span class="icon">
              <ig-icon :name="iconName(renewalRate.renewProbRise)"
                       :style="{ color: iconStyle(renewalRate.renewProbRise) }"></ig-icon>
              {{ Math.abs(renewalRate.renewProbRise) }}%
            </span>
          </div>
          <div>
            <span class="data">行业平均预测续费率：{{ renewalRate.hyAvgRenewProb }}%</span>
            <span class="icon">
              <ig-icon :name="iconName(renewalRate.hyAvgRenewProbRise)"
                       :style="{ color: iconStyle(renewalRate.hyAvgRenewProbRise) }"></ig-icon>
              {{ Math.abs(renewalRate.hyAvgRenewProbRise) }}%
            </span>
          </div>
        </div>
      </radar-map>

      <div class="radar-hint"
           slot="bottom">
        <div class="title">指标说明</div>
        <div>忠诚度：根据客户小程序/客户web端登录等数据评分</div>
        <div>价值：根据客户合作时间/提单频率/注册资金/消耗等数据评分</div>
        <div>服务情况：根据客户跟进等数据评分</div>
        <div>效果：根据询盘/询盘成本/网站浏览量/帖子浏览量等效果数据评分</div>
      </div>
    </dialog-form>

    <!-- 下载时间选择器 -->
    <dialog-form :dialogVisible="dateDoalog"
                 :attributes="dateAttributes"
                 @close:dialogVisible="val => (dateDoalog = val)"
                 @confirm="confirm">
      <date-switch-selector slot="main"
                            :groups="timeSwitch"
                            :lastDay="true"
                            :lastMonth="true"
                            :showDateData="true"
                            timeTitle="选择报告周期"
                            @reportData="reportData"
                            :customDisabledDate="customDisabledDate"></date-switch-selector>
    </dialog-form>
  </div>
</template>

<script>
import { getTaskFlowList } from '@/backend/services/task/task';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import industry from '@/components/customer/industry';
import listPageCreate from '@/mixins/listPageCreate';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import customer from '@/backend/services/account/customer';
import setmeal from '@/backend/services/account/setmeal.js';
import api from '@/backend/apiConfig/apiConfig';
import customerMinxins from '@/mixins/customer';
import userSearch from '@/components/tools/userSearch';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import { validRequired, validMobile } from '@/common/elementValid.js';
import { serviceStaff } from '@/common/dictionary.js';
import serviceConfirmation from '@/components/customer/serviceConfirmation.js';
import serviceconfirmation from '@/components/customer/serviceConfirmation.vue';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import dialogForm from '@/components/dialogForm/dialogForm';
import radarMap from '@/components/sky_charts/radarMap.vue';
import dateSwitchSelector from '@/components/dateSwitchSelector/dateSwitchSelector.vue';
import { timeSwitch } from '@/common/dictionary.js';
import { GetMonthStr } from '@/utils/index.js';
import { getDateRegion } from '@/common/util.js';
import { judgeNullValue } from '@/utils/index.js';
import popoverText from '@/components/tools/popoverText.vue';
const page = listPageCreate({
  searchConfig: {
    api: api.customer.getCustomerList,
    method: 'POST',
  },
});

export default {
  name: 'customer',
  components: {
    formCombination,
    filterPanel,
    radarMap,
    dialogForm,
    dateSwitchSelector,
    popoverText,
    serviceconfirmation,
  },
  mixins: [page, customerMinxins, beforeRouteEnter],
  data () {
    return {
      repertory: '',
      customerId: '',
      nextOrderCountTotal: '',
      nums: '',
      renewAccountIdValue: [],
      type: 'add',
      mobile: '',
      email: '',
      orderType: '',
      agentName: null,
      isHide: 'block',
      customerList: [],
      orderList: [],
      serviceConfirmation: {},
      checkList: [],
      obj: {},
      groups: {},
      customerGroups: {}, //客户信息
      dialogVisible: false,
      customerDialogVisible: false,
      orderDialogVisible: false,
      customerSureParam: {}, //继续订单确认的参数
      orderDefaultId: '',
      accountIdList: [],
      serviceOptions: [],
      isshowserve: false,
      dialogLoading: false,
      disabledItem: false,
      verify: false,
      group: {
        others: [
          // {
          //   tagName: 'sky-input',
          //   placeholder: 'CID',
          //   label: 'CID',
          //   prop: 'googleCidAccountVal',
          //   value: '',
          // },
          {
            tagName: 'sky-input',
            placeholder: '销售人员',
            label: '销售人员',
            prop: 'sellerName',
            value: '',
          },
          {
            tagName: 'sky-input-prepend',
            placeholder: '服务人员',
            label: '服务人员',
            prop: ['serviceStaffName', 'serviceStaffType'],
            value: ['', 1],
            inputStyle: {
              width: '450px',
            },
            prepend: {
              options: serviceStaff,
              style: {
                width: '180px',
              },
            },
          },
          {
            tagName: 'sky-date-picker-prepend',
            type: 'daterange',
            label: '日期',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
            prop: ['beginDate', 'endDate', 'dateType'],
            value: ['', '', 0],
            prepend: {
              type: skySelect,
              options: [
                {
                  label: '到期时间',
                  value: 0,
                },
                {
                  label: '上线时间',
                  value: 1,
                },
              ],
              style: {
                width: '230px',
              },
            },
          },
          {
            tagName: 'sky-input',
            placeholder: '渠道商名称',
            label: '渠道商名称',
            prop: 'agentName',
            value: '',
          },
        ],
        multiples: [
          {
            defaultText: '业务线',
            placeholder: '业务线',
            label: '业务线',
            options: [],
            prop: 'businessLineId',
            props: {
              label: 'name',
              value: 'id',
            },
            value: '',
          },
          {
            defaultText: '预测续费率趋势',
            placeholder: '预测续费率趋势',
            label: '预测续费率趋势',
            options: [
              {
                label: '上升',
                value: 'asc',
              },
              {
                label: '下降',
                value: 'desc',
              },
            ],
            prop: 'sortChainRatio',
            value: '',
          },
        ],
      },
      columns: [],
      btnList: [],
      showDialog: false,
      attributes: {
        width: '50%',
      },
      timeSwitch,
      dateDoalog: false,
      dateAttributes: {
        width: '45%',
        title: '下载预测续费率报告',
      },
      chartData: [],
      condition: {},
      extend: {},
      chartConfig: {},
      renewalRate: {},
      customerListId: '',
      ReportDateRange: '',
      showAgentName: false
    };
  },
  created () {
    this.filterData();
    this.getAddCustomerList(false);
  },
  computed: {
    showButton () {
      return this.getPermission(this.$permissionData.accountAffirm.englishName);
    },
  },
  methods: {
    // 客户确认列表
    async getAddCustomerList (status) {
      try {
        let res = await customer.getAddCustomerList();
        if (this.btnList.length !== 0) this.btnList[1].attribute.loading = false;
        this.nums = res.data.length;
        this.customerList = res.data;
        if (res.data.length === 0) {
          status ? this.$message.info('暂无数据') : '';
          return false;
        }
        let id = this.customerList[0].customerBusinessLineId;
        this.customerDialogVisible = status;
        this.forDataBgc(this.customerList, 0);
        this.getCustomerAccountListDetail(id);
      } catch (error) {
        this.$message.info('数据异常');
        if (this.btnList.length !== 0) this.btnList[1].attribute.loading = false;
        this.customerDialogVisible = false;
      }
    },

    forDataBgc (data, index) {
      if (!data) return false;
      data.forEach((item, idx) => {
        if (idx == index) {
          item.bgc = '#c9e6f1';
        } else {
          item.bgc = '#fff';
        }
      });
    },
    // 获取客户确认信息
    async getCustomerAccountListDetail (id) {
      let res = await customer.getCustomerAccountListDetail(id);
      this.customerSureParam = res.data;
      this.setInformationGroups(res.data);
    },
    // 已有客户订单列表
    async getHaveCustomerList () {
      try {
        let res = await customer.getHaveCustomerList();
        if (this.btnList.length !== 0) this.btnList[0].attribute.loading = false;
        this.orderList = res.data;
        this.nextOrderCountTotal = this.orderList.length;
        if (this.nextOrderCountTotal === 0) {
          this.$message.info('暂无数据');
          return false;
        }
        this.$refs.serviceconfirmation.orderDialogVisible = true;
        this.orderDefaultId = this.orderList[0].id;
        this.getOrderListDeatail(this.orderDefaultId);
      } catch (error) {
        this.$message.info('数据异常');
        if (this.btnList.length !== 0) this.btnList[0].attribute.loading = false;
        // 暂时取消弹窗消失
        // this.$refs.serviceconfirmation.orderDialogVisible = false;
      }
    },
    //临时订单列表
    async getOrderList (val) {
      let res = await customer.getOrderList({ customerId: val });
      this.orderList = res.data;
      this.forDataBgc(this.orderList, 0);
      this.nextOrderCountTotal = this.orderList.length;
      if (this.orderList && this.orderList.length !== 0) {
        this.orderDefaultId = this.orderList[0].id;
        this.getOrderListDeatail(this.orderDefaultId);
      }
    },
    // 获取临时订单详情
    async getOrderListDeatail (val) {
      try {
        let res = await customer.getOrderListDeatail(val);
        // 功能
        let { functionList } = res.data;
        if (!judgeNullValue(functionList)) {
          res.data.featureValue = functionList.map(item => {
            return `${item.name} * ${item.number * item.purchaseQuantity}/${item.unitName}、`;
          });
        }
        this.orderId = res.data.id;
        this.orderType = res.data.orderType;
        this.agentName = res.data.agentName
        this.orderGroupsData(res.data);
        this.$refs.serviceconfirmation.orderDialogVisible = true;
      } catch (error) {
        this.$message.info('获取临时订单详情失败');
        // 暂时取消弹窗消失
        // this.$refs.serviceconfirmation.orderDialogVisible = false;
      }
    },
    // 二次确认配置项
    async orderGroupsData (obj = {}) {
      let { getTaskFlowList } = this;
      let arr = [];
      try {
        arr[0] = await getTaskFlowList(0);
        arr[1] = await getTaskFlowList(1);
        arr[2] = await getTaskFlowList(2);
        arr[3] = await getTaskFlowList(3);
        arr[4] = await getTaskFlowList(4);
        arr[5] = await getTaskFlowList(5);
        arr[6] = await getTaskFlowList(6);
        arr[7] = await getTaskFlowList(7);
        arr[8] = await getTaskFlowList(10);
        arr[9] = await getTaskFlowList(21)
        arr[10] = await getTaskFlowList(22)
        arr[11] = await getTaskFlowList(23)
        this.serviceConfirmation = serviceConfirmation({
          obj,
          userSearch,
          arr,
        });
      } catch (error) {
        this.serviceConfirmation = serviceConfirmation({
          obj,
          userSearch,
          arr,
        });
      }
    },
    // 临时订单input显示隐藏
    isShow (formData, id) {
      return formData.infoList.value.some(item => item === id);
    },
    // 客户确认-取消
    customerDialogVisibleCancle () {
      this.customerDialogVisible = false;
      this.forDataBgc(this.customerList, 0);
    },
    // 根据类型获取任务流下拉列表
    async getTaskFlowList (type) {
      let res = await getTaskFlowList({
        type,
      });
      return res.data;
    },
    // 临时订单确认
    revert (cb) {
      var that = this;
      simpleFormPageCreate(
        {
          api: api.customer.getTempOrder,
          type: 'Post',
          data: this.serviceConfirmation,
        },
        res => {
          let obj = Object.assign({}, res);
          obj.customerBusinessLineId = that.$route.query.id;
          obj.id = that.orderId;
          delete obj.industryType;
          delete obj.setMealId;
          delete obj.customerName;
          delete obj.serviceId;
          delete obj.orderCode;
          delete obj.featureId;
          delete obj.infoList;
          return obj;
        }
      )
        .submit()
        .then(() => {
          if (!this.verify) {
            if (this.nextOrderCountTotal === 1) {
              this.orderId = '';
              this.query();
              cb();
            } else {
              this.orderId = '';
              this.getHaveCustomerList();
              this.query();
              cb(false);
            }
          } else {
            if (that.nums === 1) {
              this.orderId = '';
              this.query();
              cb();
            } else {
              this.orderId = '';
              this.getAddCustomerList(true);
              this.query();
              cb();
            }
          }
        })
        .catch(() => {
          cb(false);
        });
    },
    // 确认左侧list
    showCustomerList (val, index) {
      this.forDataBgc(this.customerList, index);
      this.getCustomerAccountListDetail(val);
    },
    // 二次确认左侧list
    showOrderList (val) {
      this.getOrderListDeatail(val);
    },
    // 客户确认，继续确认订单
    showDialogSecond () {
      this.$refs.customerAffirm.validate(async val => {
        if (!val) return false;
        let content = {};
        for (var index in this.customerGroups) {
          content[index] = this.customerGroups[index].value;
        }
        content.primaryIndustry = content.industry[0];
        content.secondIndustry = content.industry[1];
        delete content.industry;
        content.customerBusinessLineId = this.customerSureParam.customerBusinessLineId;
        try {
          let res = await customer.getTempCustomer(content);
          this.customerDialogVisible = false;
          this.orderDialogVisible = true;
          this.verify = true;
          this.customerId = res.data;
          this.getOrderList(res.data);
        } catch (error) {
          this.customerDialogVisible = true;
          this.orderDialogVisible = false;
        }
      });
    },
    // 客户确认配置项
    setInformationGroups (obj) {
      this.customerGroups = {
        custName: {
          label: '公司名称',
          formType: 'sky-input',
          value: obj.custName,
          rules: [validRequired('此项必填', 'blur')],
        },
        industry: {
          label: '公司行业',
          formType: industry,
          requestApi: customer.getIndustry,
          options: [],
          value: [obj.primaryIndustry, obj.secondIndustry],
          rules: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value[0] && value[1]) {
                  callback();
                } else {
                  callback(new Error('此项必填'));
                }
              },
              trigger: 'change',
            },
          ],
        },
        name: {
          label: '客户联系人',
          formType: 'sky-input',
          value: obj.name,
          rules: [validRequired('此项必填', 'blur')],
        },
        mobile: {
          label: '客户手机号',
          formType: 'sky-input',
          inputType: 'tel',
          value: obj.mobile,
          rules: [validRequired('此项必填', 'blur'), validMobile()],
        },
        email: {
          label: '客户邮箱',
          formType: 'sky-input',
          value: obj.email,
          rules: [validRequired('此项必填', 'blur')],
        },
        sellerId: {
          label: '销售联系人',
          type: 'custom',
          formType: userSearch,
          value: obj.sellerId,
          rules: [validRequired('此项必填', 'change')],
        },
        waiterId: {
          label: '服务人员联系人',
          formType: userSearch,
          type: 'custom',
          value: obj.waiterId,
          rules: [validRequired('此项必填', 'change')],
        },
      };
    },
    // 编辑弹窗配置项
    setGroups (obj) {
      this.groups = {
        custName: {
          label: '客户名称',
          formType: 'sky-input',
          value: obj.custName,
        },
        industry: {
          label: '客户行业',
          type: 'custom',
          formType: industry,
          requestApi: customer.getIndustry,
          options: [],
          value: [obj.primaryIndustry, obj.secondIndustry],
        },
        serve: {
          label: '业务线',
          formType: 'sky-text',
          value: obj.businessLineName || '暂无',
          show: this.isshowserve,
        },
        name: {
          label: '客户联系人',
          formType: 'sky-input',
          value: obj.name,
          trigger: function () { },
        },
        mobile: {
          label: '客户手机号',
          formType: 'sky-input',
          value: obj.mobile,
        },
        email: {
          label: '客户邮箱',
          formType: 'sky-input',
          value: obj.email,
        },
        sellerId: {
          label: '销售联系人',
          type: 'custom',
          formType: userSearch,
          value: obj.sellerId,
        },
        waiterId: {
          label: '服务人员联系人',
          formType: userSearch,
          type: 'custom',
          value: obj.waiterId,
        },
      };
    },
    // 新增确认
    submit () {
      // 拼接地址
      // id: 当前套餐id
      // id： 业务线id
      this.dialogLoading = true;
      let id = this.obj.customerBusinessLineId;
      let businessLineId = this.obj.businessLineId;
      let [requestApi, type] = [api.customer.addCustomer, 'Post'];
      if (this.obj.id) {
        type = 'Put';
        requestApi = `${requestApi}/${id}?businessLineId=${businessLineId}`;
      }
      simpleFormPageCreate(
        {
          api: requestApi,
          type: type,
          data: this.groups,
        },
        res => {
          let obj = Object.assign({}, res);
          obj.primaryIndustry = obj.industry[0];
          obj.secondIndustry = obj.industry[1];
          delete obj.industry;
          if (this.obj.id) {
            obj.customerId = this.obj.id;
          }
          return obj;
        }
      )
        .submit()
        .then(() => {
          this.btnLoading = false;
          this.dialogVisible = false;
          this.dialogLoading = false;
          this.query();
        })
        .catch(() => {
          this.dialogLoading = false;
        });
    },
    // 业务线下拉数据
    async filterData () {
      let res = await setmeal.getserveList();
      this.group.multiples[0].options = res.data;
    },
    setCustomer () {
      let that = this;
      this.columns = [
        {
          label: '客户名称',
          type: 'custInfo',
          main: 'custName',
          event (row) {
            that.$router.push({
              name: 'customerDetail',
              query: {
                id: row.id,
              },
            });
          },
          text:[
            {
              label: '',
              bind: 'agentName',
              class: 'pad-left',
              custValue (val) {
                if (val.agentName) {
                  return '渠道商：'+ val.agentName
                } else {
                  return " "
                }
              },
             
            }
          ]
        },
        {
          label: '客户联系方式',
          type: 'custInfo',
          text: [
            {
              label: '联系人',
              bind: 'name',
            },
            {
              label: '手机',
              bind: 'mobile',
            },
            {
              label: '邮箱',
              bind: 'email',
            },
          ],
        },
        {
          label: '销售联系方式',
          type: 'custInfo',
          text: [
            {
              label: '联系人',
              bind: 'seller',
            },
            {
              label: '手机',
              bind: 'sellerMobile',
            },
            {
              label: '邮箱',
              bind: 'sellerEmail',
              textStyle: {
                '-webkit-line-clamp': 1,
              },
            },
          ],
        },
        {
          label: '服务人员',
          type: 'custInfo',
          text: [
            {
              label: '网站',
              bind: 'siteServiceStaff',
              colType: 'serviceInfo',
              width: '300',
            },
            {
              label: '社媒',
              bind: 'socialServiceStaff',
              colType: 'serviceInfo',
              width: '300',
            },
            {
              label: 'Google推广',
              bind: 'googleServiceStaff',
              colType: 'serviceInfo',
              width: '300',
            },
            {
              label: '视频拍摄',
              bind: 'videoServiceStaff',
              colType: 'serviceInfo',
              width: '300',
            },
            {
              label: 'FB推广',
              bind: 'facebookServiceStaff',
              colType: 'serviceInfo',
              width: '300',
            },
          ],
          formatter (item, row) {
            return `${item.label}：${(row[item.bind] && row[item.bind].username) || '-'} `;
          },
          dataStyle (scope, tableData, bind) {
            let res = scope.row[bind];
            if (!res) return false;
            return {
              name: res.username || '-',
              corp: res.companyName || '-',
              deptName: res.deptName || '-',
              mobile: res.phone || '-',
              email: res.email || '-',
            };
          },
        },
        {
          label: '到期时间',
          type: 'custInfo',
          text: [
            {
              label: '套餐',
              bind: 'setMealName',
              disabled: true,
            },
            {
              disabled: true,
              class: 'active',
              bind: 'formatExpirationTime',
            },
            {
              label: '上线时间',
              disabled: true,
              bind: 'formatUpLineDate',
            },
          ],
          sort: 'expirationTime',
          options: [
            {
              label: '由低到高',
              value: 'asc',
            },
            {
              label: '由高到低',
              value: 'desc',
            },
          ],
        },
        {
          label: '服务单数',
          bind: 'serviceCount',
          align: 'center',
          width: '85'
        },
        {
          label: '预测续费率',
          type: 'custInfo',
          content:
            '预测续费率：根据客户成效数据等推算出的客户可能续费的概率。该预测续费率为客户最近服务单的预测续费率',
          text: [
            {
              label: '',
              bind: 'renewalRate',
              disabled: true,
              custValue (val) {
                if (!judgeNullValue(val.renewalRate)) {
                  return `${val.renewalRate}%`;
                }
                return '-';
              },
            },
            {
              bind: 'renewalChainRatio',
              showIcon: true,
              custIcon (row) {
                let color = '';
                let name = '';
                let val = row.renewalChainRatio;
                val = parseFloat(val);
                if (val > 0) {
                  color = '#F5222D';
                  name = 'shangsheng';
                } else {
                  color = '#52c41a';
                  name = 'xiajiang';
                }
                return {
                  name,
                  style: {
                    color: color,
                    'font-size': '10px',
                    'margin-right': '5px',
                  },
                };
              },
              custValue (row) {
                return `${Math.abs(row.renewalChainRatio)}%` || '-';
              },
              popover () {
                return {
                  disabled: true,
                };
              },
            },
          ],
          dataHint (row) {
            if (judgeNullValue(row.serviceId)) {
              return false;
            }
            return {
              name: 'tishi',
              async click (scope) {
                let id = scope.row.serviceId;
                let res = await customer.renewalRateChartData({
                  serviceId: id,
                });
                if (judgeNullValue(res.data)) {
                  that.$message.warning('暂无数据');
                  return false;
                }
                that.extend = {
                  legend: {
                    show: true,
                    formatter (val) {
                      return val == 1 ? '客户数据' : '行业平均';
                    },
                  },
                  tooltip: {
                    formatter (data) {
                      let name = data.name == 1 ? '客户数据' : '行业平均';
                      let val = data.value;
                      return [
                        name,
                        `忠诚度：${val[0]}`,
                        `价值：${val[1]}`,
                        `服务情况：${val[2]}`,
                        `效果：${val[3]}`,
                      ].join('<br/>');
                    },
                  },
                  radar: {
                    radius: '60%',
                    shape: 'polygon',
                    indicator: [
                      {
                        name: '忠诚度',
                        max: 100,
                      },
                      {
                        name: '价值',
                        max: 100,
                      },
                      {
                        name: '服务情况',
                        max: 100,
                      },
                      {
                        name: '效果',
                        max: 100,
                      },
                    ],
                  },
                };
                that.chartConfig = {
                  type: 'veRadar',
                  columns: ['dimType', 'loyal', 'value', 'serviceCase', 'effect'],
                  chartSettings: {
                    labelMap: {
                      loyal: '忠诚度',
                      value: '价值',
                      serviceCase: '服务情况',
                      effect: '效果',
                    },
                    areaStyle: {
                      options: 0.3,
                    },
                  },
                };
                that.renewalRate = res.data;
                that.chartData = res.data.dataList;
                that.attributes.title = `${res.data.customerName || ''} （${res.data.startDate
                  } 至 ${res.data.endDate}）`;
                that.showDialog = true;
              },
            };
          },
          sort: 'renewalRate',
          options: [
            {
              label: '由低到高',
              value: 'asc',
            },
            {
              label: '由高到低',
              value: 'desc',
            },
          ],
        },
        {
          label: 'APP绑定/邮箱绑定/添加账号数', //  即将生效可编辑，正在生效可编辑状态，关闭不可编辑
          bind (val) {
            let { appBindCount, accountCount, emailBindCount } = val
            return `${appBindCount}/${emailBindCount}/${accountCount}`
          },
        },
        {
          label: '操作',
          type: 'iconbutton',
          align: 'center',
          iconlist: [
            {
              name: 'chakanxiangqing',
              message: '查看详情',
              style: {
                color: '#333',
              },
              showButton () {
                return that.getPermission(that.$permissionData.accountViewDetail.englishName);
              },
              callback: function (row) {
                that.$router.push({
                  name: 'customerDetail',
                  query: {
                    id: row.id,
                  },
                });
              },
            },
            {
              name: 'bianji',
              message: '编辑',
              style: {
                color: '#333',
              },
              showButton () {
                return that.getPermission(that.$permissionData.accountEdit.englishName);
              },
              callback: function (row) {
                customer
                  .getCustomerDetail({
                    customerId: row.id,
                  })
                  .then(val => {
                    that.obj = val.data;
                    that.setGroups(val.data);
                    that.dialogVisible = true;
                  });
              },
            },
            {
              name: 'accountmanagement',
              message: '账号管理',
              style: {
                color: '#333',
              },
              showButton () {
                return that.getPermission(that.$permissionData.accountManagement.englishName);
              },
              callback (row) {
                that.$router.push({
                  name: 'customerAccount',
                  query: {
                    id: row.id,
                    serviceLineId: row.customerBusinessLineId,
                  },
                });
              },
            },
            {
              name: 'xiazai',
              message: '下载',
              style: {
                color: '#333',
              },
              showButton () {
                return that.getPermission(
                  that.$permissionData.downloadRenewalRateReport.englishName
                );
              },
              async callback (row) {
                that.dateDoalog = true;
                that.customerListId = row.id;
              },
            },
          ],
        },
      ];
      this.btnList = [
        {
          name: '已有客户订单',
          position: 'right',
          showBtn: that.showButton,
          attribute: {
            type: 'primary',
            size: 'small',
            loading: false,
          },
          btnClick () {
            that.verify = false;
            that.btnList[0].attribute.loading = true;
            that.getHaveCustomerList();
          },
        },
        {
          name: '客户确认',
          position: 'right',
          showBtn: that.showButton,
          attribute: {
            type: 'primary',
            size: 'small',
            loading: false,
          },
          badge: {
            value: that.nums,
          },
          async btnClick () {
            that.btnList[1].attribute.loading = true;
            await that.getAddCustomerList(true);
          },
        },
      ];
    },
    reportData (val) {
      this.ReportDateRange = val;
    },
    async confirm (callback) {
      try {
        let val = this.ReportDateRange;
        let res = await customer.downloadRenewalRate({
          customerId: this.customerListId,
          startDate: val.startDate,
          endDate: val.endDate,
        });
        if (judgeNullValue(res.data)) {
          this.$message.warning('所选时间段数据缺失');
          callback && callback();
          return false;
        }
        let fileName = decodeURI(res.headers['content-disposition']).split('=');
        let blob = new Blob([res.data]);
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName[1]);
        document.body.appendChild(link);
        link.click();
        callback && callback();
      } catch (error) {
        callback && callback();
      }
    },
    customDisabledDate (time, type) {
      if (type == 'WEEKLY') {
        //按周日为一周的最后一天计算
        var week = new Date();
        //今天是这周的第几天
        var today = week.getDay() * 24 * 3600 * 1000;
        return time.getTime() > Date.now() - today;
      }
      if (type == 'DAILY') {
        // 三个月的开始结束时间
        let date = GetMonthStr(3, 'day');
        let day = getDateRegion('DAY').split('至')[1];
        date.now = day;
        let start = new Date(date.now).getTime();
        return time.getTime() > start;
      }
      if (type == 'MONTHLY') {
        // 三个月的开始结束时间
        let end;
        let month = getDateRegion('MONTH').split('至')[1];
        end = new Date(month).getTime();
        return time.getTime() > end;
      }
    },
    iconName (val) {
      return parseFloat(val) > 0 ? 'shangsheng' : 'xiajiang';
    },
    iconStyle (val) {
      return parseFloat(val) > 0 ? '#F5222D' : '#52C41A';
    },
  },
  watch: {
    'customerGroups.name.value': {
      handler () {
        var that = this;
        this.accountIdList.map(k => {
          if (that.customerGroups.name.value == k.accountId) {
            that.customerGroups.email.value = k.email;
            that.customerGroups.mobile.value = k.mobile;
          }
        });
      },
      immediate: true,
    },
    data: {
      handler () {
        this.setCustomer();
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.customer-file {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: relative;
}

.btn-top {
	width: 100%;
	height: 60px;
	margin: 10px 0;
	padding: 0 20px;
	padding-bottom: 10px;
	background-color: #fff;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
}

.list {
	height: 650px;
	overflow-y: auto;
}

// 改变滚动条样式
.list::-webkit-scrollbar {
	width: 4px;
}

.list::-webkit-scrollbar-thumb {
	background-color: #d8d8d8;
	border-radius: 2px;
}

.list::-webkit-scrollbar-track {
	background-color: #fff;
	border-radius: 2px;
}

.customerListItem {
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 10px;
	user-select: none;
	cursor: pointer;
}

.customerListItem .popover-text {
	margin-right: 6px;
}

.customerListItem .popover-text.order-code {
	margin-right: 6px;
}

.customerListItem .popover-text.package-name {
	margin-right: 0;
	margin-left: 6px;
}

.customerActive {
	background: rgb(201, 230, 241);
}

.average {
	line-height: 25px;

	.icon {
		margin-left: 10px;

		.iconfont {
			font-size: 12px;
		}
	}
}

.radar-hint {
	color: #333;
	font-size: 12px;
	line-height: 17px;
	margin-left: 20px;

	.title {
		font-weight: bold;
		margin-bottom: 5px;
	}
}
</style>
